<template>
  <div class="privacy-policy">

    <h2>Privacy policy</h2>

    <div class="table">
      <div>Name of the Service</div>
      <div>SQAaaS Web</div>
      <div>Description of the service</div>
      <div>Client for the authentication process of users who access the <a href="https://sqaaas.eosc-synergy.eu" target="_blank">SQAaaS website.</a></div>
      <div>Data controller and a contact person</div>
      <div>EOSC-Synergy - sqaaas@ibergrid.eu <i class="fa fa-envelope fa-sm"></i></div>
      <div>Purpose of the processing of personal data</div>
      <div>The EGI Check-in service provides a Token for authorised users. In order to authenticate the users in the website the token is exchanged with the API to validate the access to the service.</div>
      <div>Third parties to whom personal data is disclosed</div>
      <div>Personal data shall not be transferred to any third party outside the EU.</div>
      <div>Data retention</div>
      <div>In general, personal data is not stored.</div>
      <div>Data Protection Code of Conduct</div>
      <div>Personal data will be protected according to the <a href="https://geant3plus.archive.geant.net/Pages/uri/V1.html" target="_blank">Code of Conduct for Service Providers</a>, a common standard for the research and higher education sector to protect the user's privacy.</div>
    </div>

  </div>
</template>

<script>

  import TopNavbar from '../layout/TopNavbar.vue'
  import ContentFooter from '../layout/ContentFooter'

  export default {
    components: {
      TopNavbar,
		  ContentFooter,
    }
  }

</script>

<style scoped>

  .privacy-policy {
    margin: 2em 8%;

    h2 {
      font-weight: bold;
      color: #343434;
    }

    .table {
      display: grid;
      grid-template-columns: 15em 1fr;
      gap: 1px;
      margin: 1em;
      background-color: #e5e5e5;

      div { padding: 1em; }

      div:nth-child(odd) {
        font-weight: bold;
        background-color: #f0f0f0;
        text-align: end;
      }

      div:nth-child(even) { background-color: white; }
    }

    .fa-envelope { color: #606060; }

    @media (max-width: 700px) {
      .table {
          grid-template-columns: 1fr;
          margin: 0;
          div:nth-child(odd) { text-align: start; }
          div:nth-child(even) { padding-bottom: 2em; }
      }
    }
  }

</style>
